// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 3.6vh 0;\n}\n.timer--countdown {\n  font-size: 3.2rem;\n  font-weight: bold;\n  color: #6a79e5;\n}", ""]);
// Exports
module.exports = exports;
